import { Button, Grid, Stack } from '@mui/material';
import CusFormField from 'components/CusFormField';
import MainCard from 'components/MainCard';
import useMain from 'hooks/useMain';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { userAdminService } from 'services/userAdmin';
import { handleAsyncCall } from 'utils/common';
import { profileFields } from './field';
import CloseIcon from '@mui/icons-material/Close';

const UserProfile = () => {
  const {
    control,
    setError,
    handleSubmit,
    getValues,
    formState: { errors },
    reset,
    watch
  } = useForm({});
  const { t, upperCaseLang, useNavigate } = useMain();

  const navigate = useNavigate();
  const onSubmit = (data) => {};
  useEffect(() => {
    handleAsyncCall({
      service: userAdminService.getUserDetail,
      successCb: (res) => {
        const details = {
          CompanyName: res?.data[`CompanyName${upperCaseLang}`],
          ...res?.data
        };
        reset(details);
      }
    });
  }, []);

  return (
    <MainCard>
      <Stack direction="row" justifyContent="flex-end" mb={2}>
        <Button variant="contained" onClick={() => navigate(-1)}>
          <CloseIcon />
        </Button>
      </Stack>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          {profileFields({ t }).map((props) => (
            <CusFormField
              key={props.id}
              id={props.id}
              {...props}
              control={control}
              fieldProps={{
                ...props.fieldProps,
                disabled: true
              }}
            />
          ))}
        </Grid>
      </form>
    </MainCard>
  );
};

export default UserProfile;
